module.exports = __webpack_public_path__ + "fonts/Golos-Text_Bold.2c74b6f.eot";